module.exports = __webpack_public_path__ + "img/4.15f133df.jpg";